import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import CheckboxField from "../../../components/Fields/CheckboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import { NewItemRevisionStatusModes } from "../../../enums/NewItemRevisionStatusModes";
import ItemRevisionModel from "../../../models/ItemRevisionModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface CreateNewItemRevisionModel {
    itemId: number
    keepStatus: boolean
}

interface ItemRevisionPopupProps {
    show: boolean
    onHide: (newItemRevisionId?: number) => void
    itemRevision: ItemRevisionModel
}

const CreateNewItemRevisionPopup: React.FC<ItemRevisionPopupProps> = ({ show, onHide, itemRevision }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<CreateNewItemRevisionModel>({
        itemId: itemRevision.itemId,
        keepStatus: itemRevision.item.itemType.newItemRevisionStatusModeId == NewItemRevisionStatusModes.Reset ? false : true
    });

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/ItemRevisions`, formData)
                .then(response => {
                    handleResult(response)
                    setServerErrors(response)
                    if (response.isSuccesful === true) {
                        onHide(response.data);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'keepStatus', label: 'Keep the current item status', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Create new revision'} >
            <Popup.Body>
                {itemRevision.item.itemType.newItemRevisionStatusModeId == NewItemRevisionStatusModes.Ask && <CheckboxField {...getFieldProps('keepStatus')} />}
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Create' />
            </Popup.Footer>
        </Popup>
    );
}
export default CreateNewItemRevisionPopup;